import { performRequest } from 'common/utils/performRequest';

export const GET_PROPERTY_DETAILS_REQUEST = 'GET_PROPERTY_DETAILS_REQUEST';
export const GET_PROPERTY_DETAILS_SUCCESS = 'GET_PROPERTY_DETAILS_SUCCESS';
export const GET_PROPERTY_DETAILS_FAILURE = 'GET_PROPERTY_DETAILS_FAILURE';

export default function getPropertyDetail(brand, pid, values = {}) {
  return async dispatch => {
    dispatch({
      type: GET_PROPERTY_DETAILS_REQUEST,
    });

    try {
      const header = { action: 'RETRIEVE_GDS' };
      const { data } = await performRequest(
        'get',
        `/api/content/dashboard/property-details/${brand}/${pid}/en`,
        header
      );

      const { guestRooms = [] } = values;
      const updatedGuestRooms = data.prop.guestRooms.map((room, index) => ({
        ...room,
        // nameOptions: guestRooms[index]?.nameOptions || [],
        show: guestRooms[index]?.show,
      }));

      const formData = {
        ...data.prop,
        guestRooms: updatedGuestRooms,
      };

      dispatch({
        type: GET_PROPERTY_DETAILS_SUCCESS,
        payload: formData,
      });
    } catch (error) {
      dispatch({
        type: GET_PROPERTY_DETAILS_FAILURE,
        payload: error.response.data,
      });
    }
  };
}
